<template>
  <div>
    <!-- 캘린더 -->
    <template v-if="prod.id">
      <div v-if="dates.length>0" class="reservation-calendar">
        <div class="grid-cal-title">
          <div>
            <button class="button button-now" @click="clickNow">오늘</button>
          </div>
          <!-- 연,월 -->
          <div class="flex flex-center justify-center">
            <div class="flex-align" style="gap:0 8px">
              <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
              <div class="size-18">{{ `${currentDate.year()}년 ${currentDate.month()+1}월` }}</div>
              <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
            </div>
          </div>
          <div class="flex-end" style="gap:8px">
            <button class="button" style="width:72px" @click="initAll">
              <span class="flex-align" style="gap:4px">
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3333 2.75016H8.66667V2.0835C8.66667 1.55306 8.45595 1.04436 8.08088 0.669283C7.70581 0.29421 7.1971 0.0834961 6.66667 0.0834961H5.33333C4.8029 0.0834961 4.29419 0.29421 3.91912 0.669283C3.54405 1.04436 3.33333 1.55306 3.33333 2.0835V2.75016H0.666667C0.489856 2.75016 0.320286 2.8204 0.195262 2.94543C0.0702379 3.07045 0 3.24002 0 3.41683C0 3.59364 0.0702379 3.76321 0.195262 3.88823C0.320286 4.01326 0.489856 4.0835 0.666667 4.0835H1.33333V11.4168C1.33333 11.9473 1.54405 12.456 1.91912 12.831C2.29419 13.2061 2.8029 13.4168 3.33333 13.4168H8.66667C9.1971 13.4168 9.70581 13.2061 10.0809 12.831C10.456 12.456 10.6667 11.9473 10.6667 11.4168V4.0835H11.3333C11.5101 4.0835 11.6797 4.01326 11.8047 3.88823C11.9298 3.76321 12 3.59364 12 3.41683C12 3.24002 11.9298 3.07045 11.8047 2.94543C11.6797 2.8204 11.5101 2.75016 11.3333 2.75016ZM4.66667 2.0835C4.66667 1.90669 4.7369 1.73712 4.86193 1.61209C4.98695 1.48707 5.15652 1.41683 5.33333 1.41683H6.66667C6.84348 1.41683 7.01305 1.48707 7.13807 1.61209C7.2631 1.73712 7.33333 1.90669 7.33333 2.0835V2.75016H4.66667V2.0835ZM9.33333 11.4168C9.33333 11.5936 9.2631 11.7632 9.13807 11.8882C9.01305 12.0133 8.84348 12.0835 8.66667 12.0835H3.33333C3.15652 12.0835 2.98695 12.0133 2.86193 11.8882C2.7369 11.7632 2.66667 11.5936 2.66667 11.4168V4.0835H9.33333V11.4168Z" fill="#787878"/>
                </svg>
                <span style="size:13px;flex:1;color:#363636">초기화</span>
              </span>
            </button>
            <button class="button is-primary button-set" style="width: 103px"
                    @click="clickAdd">+ 일정 추가</button>
          </div>
        </div>
        <!-- 요일 -->
        <div class="lp-days">
          <div class="lp-day" v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
        </div>
        <!-- 일 -->
        <div class="lp-dates">
          <div class="lp-date unselect" :class="{'lp-date-before': date.before,
                                                      'lp-date-not': date.possible_resv === false}"
               v-for="(date,idx) in dates" :key="'date-'+idx"
               @click="clickDate(date)">
            <div class="day-num" :class="{'day-num-now': date.now}">{{date.day }}</div>
            <template v-if="date.schedule && date.schedule.length>0">
              <div v-for="(sch,sIdx) in date.schedule.slice(0, 2)" :key="`sch-${sIdx}`"
                   class="item-time"
                   @click.stop.prevent="clickTime(date,sch)"
              >{{ sch.start_time.substring(0,5) + '~' + sch.end_time.substring(0,5) }}</div>
              <div class="item-time-more" v-if="date.schedule.length>2"
                   @click.stop.prevent="clickMore(date)">{{ date.schedule.length - 2 }}개 일정 더보기</div>
              <div class="flex" v-if="date.ordered_count && date.ordered_count>0">
                <div class="day-ordered">예약 {{ date.ordered_count }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <modal-reserve-schedule ref="scheduleModal" :prod="prod"
                            :selectedDate="selectedDate"
                            :reservePolicy="reservePolicy"
                            :reservePrice="reservePrice"
                            :selectorStocks="selectorStocks"
                            @accept="onAccept"></modal-reserve-schedule>
    <modal-reserve-schedule-update ref="scheduleUpdateModal"
                                   :prod="prod"
                                   :selectedTime="selectedTime"
                                   :reservePrice="reservePrice"
                                   :reservePolicy="reservePolicy"
                                   @accept="onAccept"></modal-reserve-schedule-update>
  </div>
</template>

<script>
  import moment from 'moment'
  import BlockNegative from "./BlockNegative";
  import ModalReserveSchedule from "./ModalReserveSchedule";
  import ModalReserveScheduleUpdate from "./ModalReserveScheduleUpdate";

  export default {
    name: 'ProductReservationMonthly',
    components: {
      ModalReserveScheduleUpdate,
      ModalReserveSchedule,
      BlockNegative
    },
    props: {
      prod: {
        type: Object
      },
      propDate: {
        type: String
      },
      reservePolicy: {
        type: Object
      },
      reservePrice: {
        type: Array
      },
      selectorStocks: {
        type: Array
      }
    },
    created() {
      this.now = moment();
      this.currentDate = this.propDate ? moment(this.propDate) : moment();
      this.getDates();
    },
    data() {
      return {
        days: ['일','월','화','수','목','금','토'],
        dates: [],
        currentDate: '',
        selectedDate: undefined,
        selectedTime: undefined,
        now: ''
      }
    },
    methods: {
      staticPath(img) {
        return `https://launchpack.co.kr${img}`;
      },
      initAll() {
        if(confirm('오늘 이후에 예약이 없는 모든 일정이 삭제됩니다.')) {
          this.$axios.delete(this.getUrl(`reservation/product/${this.prod.id}/schedule/init`)).then(()=> {
            this.toastStatus('일정이 초기화되었습니다.');
            this.getDates();
          }).catch(()=>{
            this.toastStatus('일정 초기화에 실패했습니다.');
          });
        }
      },
      clickTime(date,sch) {
        // // test
        // sch.ordered_count = 1;
        this.selectedTime = sch;
        this.selectedTime.org = date.org;
        setTimeout(()=>{
          this.$refs.scheduleUpdateModal.open();
        }, 100);
      },
      clickMore(date) {
        this.currentDate = moment(date.date_str);
        this.$emit('more', date);
      },
      clickNow() {
        this.currentDate = moment(this.now.format('YYYY-MM-DD'));
        this.getDates();
      },
      clickPrev() {
        this.currentDate.subtract(1, 'months');
        this.getDates();
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        this.getDates();
      },
      getDates() {
        if(this.prod.id) {
          let year = this.currentDate.year();
          let month = this.currentDate.month()+1;
          this.$axios.get(this.getUrl(`reservation/product/${this.prod.id}/calendar/${year}/${month}`)).then(res => {
            this.dates = res.data;
          });
        }
      },
      clickDate(date) {
        if(!date.before) {
          this.selectedDate = this.cloneItem(date);
          setTimeout(()=>{
            this.$refs.scheduleModal.open();
          }, 100);
        }
      },
      clickAdd() {
        this.selectedDate = undefined;
        setTimeout(()=>{
          this.$refs.scheduleModal.open();
        }, 100);
      },
      onAccept() {
        this.getDates();
      }
    }
  }
</script>

<style lang="stylus" scoped>

  .reservation-calendar
    margin-top 24px

  .grid-cal-title
    display grid
    grid-template-columns repeat(3, 1fr)
    margin-bottom 12px
    align-items center

  .button-now
    width 76px
  .button-set
    width 132px

  .lp-days
    display grid
    grid-template-columns repeat(7, 1fr)
  .lp-day
    text-align center
    padding-bottom 4px
    color #4f4f4f
    height 40px
    line-height 40px

  .lp-dates
    display grid
    grid-template-columns repeat(7, 1fr)
    border-top 1px solid #dddddd
    border-left 1px solid #dddddd

  .lp-date
    width 100%
    height 180px
    border-right 1px solid #dddddd
    border-bottom 1px solid #dddddd
    padding 6px
    font-size 12px
  .lp-date-before
    background-color #F5F5F5
    color #989898 !important

  .lp-date-not
    background url(/office/static/icon/pattern.svg)
    background-position center
    background-size cover
    background-repeat no-repeat
    .day-num
      text-decoration line-through


  .day-num-now
    color white
    background-color #ff5722
    border-radius 100%
    width 16px
    height 16px
    line-height 16px
    text-align center

  .lp-date:hover
    // background #f5f5f5
    border 2px solid #363636

  .icon-arrow
    padding 0 8px
    height 22px

  .day-price
    margin-top 10px
    font-size 13px
  .day-unit
    font-size 12px
    color #787878
  .day-ordered
    margin-top 4px
    color white
    background-color #363636
    border-top-right-radius 20px
    border-bottom-right-radius 20px
    padding 2px 8px 2px 6px
    font-size 12px
    display flex
    align-items center
    height 18px

  .item-time
    margin-top 4px
    background-color #FFF0EB
    border-radius 4px
    padding 5px 6px
    font-size 14px
    color #E53700
  .item-time:hover
    background-color #FFCEA6

  .item-time-more
    margin-top 4px
    padding 5px 6px
    font-size 14px
    color #787878
  .item-time-more:hover
    background-color #F5F5F5

  .negative
    background-color #FFF0EB
    color #ff5722
    font-size 13px
    line-height 18.82px
    padding 12px 16px
    display flex
    gap 0 12px
    img
      margin-top 2px
      height 16px
  .not-txt
    flex 1
    white-space pre-line
    padding-right 8px
</style>
